import React from "react";

// ─── Color Helpers ─────────────────────────────────────────────
export const scoreColor = (v) =>
  v >= 80 ? "#10b981" : v >= 60 ? "#f59e0b" : "#ef4444";

export const scoreLabel = (v) =>
  v >= 80 ? "Healthy" : v >= 60 ? "Warning" : "Critical";

export const statusColor = (s) => {
  const m = {
    Good: "#10b981", Normal: "#10b981", Warning: "#f59e0b",
    Critical: "#ef4444", Running: "#10b981", Fault: "#ef4444",
    Standby: "#6b7280", Off: "#94a3b8",
  };
  return m[s] || "#94a3b8";
};

// ─── Score Ring ────────────────────────────────────────────────
export const ScoreRing = ({ value, size = 100 }) => {
  const r = (size / 2) - 10;
  const circ = 2 * Math.PI * r;
  const fill = (value / 100) * circ;
  const color = scoreColor(value);
  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e2e8f0" strokeWidth="8" />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth="8"
        strokeDasharray={`${fill} ${circ}`} strokeLinecap="round"
        style={{ transition: "stroke-dasharray 0.8s ease" }}
      />
      <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle"
        style={{ transform: "rotate(90deg)", transformOrigin: "center", fill: color, fontSize: size > 80 ? 20 : 14, fontWeight: 800 }}>
        {value}
      </text>
    </svg>
  );
};

// ─── Mini Bar ─────────────────────────────────────────────────
export const MiniBar = ({ value, max, color = "#667eea", height = 6 }) => (
  <div style={{ background: "#e2e8f0", borderRadius: 9999, overflow: "hidden", height }}>
    <div style={{
      width: `${Math.min((value / max) * 100, 100)}%`,
      height: "100%",
      background: color,
      borderRadius: 9999,
      transition: "width 0.6s ease",
    }} />
  </div>
);

// ─── KPI Card ─────────────────────────────────────────────────
export const KpiCard = ({ icon: Icon, label, value, sub, color = "#667eea", onClick }) => (
  <div className="fm-kpi-card" onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }}>
    <div className="fm-kpi-icon" style={{ background: `${color}18`, color }}>
      <Icon size={20} />
    </div>
    <div className="fm-kpi-body">
      <div className="fm-kpi-value">{value}</div>
      <div className="fm-kpi-label">{label}</div>
      {sub && <div className="fm-kpi-sub">{sub}</div>}
    </div>
  </div>
);

// ─── Severity Badge ───────────────────────────────────────────
export const SeverityBadge = ({ s }) => {
  const map = { Critical: "fm-badge-critical", Warning: "fm-badge-warning", Info: "fm-badge-info" };
  return <span className={`fm-badge ${map[s] || "fm-badge-info"}`}>{s}</span>;
};
